import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import Input, { InputProps } from '../DiComponents/Inputs';

import { coalesceFieldErrors } from './utils';

type Props = FieldRenderProps & InputProps;

export default class DiInputAdapter extends React.Component<Props> {
  render() {
    const { input, meta, ...props } = this.props;
    let valid;
    if (meta.touched) {
      valid = coalesceFieldErrors(meta).length === 0;
    }
    return <Input {...input} {...props} valid={valid} />;
  }
}
